var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileMen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "u6lca"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 22V-1h20v23zm12.181-10.428a5.835 5.835 0 0 1-4.882 0H6.74a4.501 4.501 0 0 0-4.5 4.5v1.392c0 .888.72 1.608 1.607 1.608h11.786c.887 0 1.607-.72 1.607-1.608v-1.392c0-2.485-2.015-4.5-4.5-4.5zM9.741 10.5a4.285 4.285 0 1 0 0-8.57 4.285 4.285 0 0 0 0 8.57z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#333",
    strokeMiterlimit: 20,
    strokeWidth: 4,
    d: "M12.74 11.572c2.485 0 4.5 2.015 4.5 4.5v1.392c0 .888-.72 1.608-1.607 1.608H3.847c-.887 0-1.607-.72-1.607-1.608v-1.392c0-2.485 2.016-4.5 4.5-4.5h.56a5.835 5.835 0 0 0 4.882 0zM5.455 6.214a4.285 4.285 0 1 1 8.57 0 4.285 4.285 0 0 1-8.57 0z",
    clipPath: "url(\"#u6lca\")"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileMen);
export default __webpack_public_path__ + "static/media/profile_men.da2b72905f08c64f3394e43ed6cc9b2f.svg";
export { ForwardRef as ReactComponent };